import script from "./QuestionContent.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionContent.vue?vue&type=script&setup=true&lang=js"

import "./QuestionContent.vue?vue&type=style&index=0&id=42c3b3c4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c3b3c4"]])

export default __exports__